import apiClient from "./axios"

export const getAccountVendors = async (params = {}) => {
  const { data } = await apiClient.get("/account-vendors", { params })
  return data
}

export const getAccountVendor = async id => {
  const { data } = await apiClient.get(`/account-vendors/${id}`)
  return data
}

export const createAccountVendor = async payload => {
  const { data } = await apiClient.post("/account-vendors", payload)
  return data
}

export const updateAccountVendor = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-vendors/${id}`, payload)
  return data
}

export const deleteAccountVendor = async id => {
  const { data } = await apiClient.delete(`/account-vendors/${id}`)
  return data
}
